import React, { useMemo } from 'react';
import { Field, FieldTypes } from '@common-fe/common-fe';

import Label from '@/components/elements/Label';
import { EmailCommunication } from '@/modules/employer/types/Contact.types';

interface Props {
  values?: EmailCommunication;
  isAllEmailCommunicationsSelected?: boolean;
}

const useEmailCommunicationsFields = ({ values }: Props) => {
  const fields: Field[] = useMemo(
    () => [
      {
        name: 'finance',
        type: FieldTypes.Toggle,
        label: (
          <Label
            title="Finance"
            desc="Contributions, replenishment, and other financial operations"
            width='200px'
          />
        ),
        value: !!values?.finance,
        defaultValue: !!values?.finance,
      },
      {
        name: 'files',
        type: FieldTypes.Toggle,
        label: <Label title="Files" desc="File confirmation and error reports" />,
        value: !!values?.files,
        defaultValue: !!values?.files,
      },
      {
        name: 'planManagement',
        type: FieldTypes.Toggle,
        label: <Label title="Plan Management" desc="Employer and plan status updates" />,
        value: !!values?.planManagement,
        defaultValue: !!values?.planManagement,
      },
      {
        name: 'reports',
        type: FieldTypes.Toggle,
        label: <Label title="Reports" />,
        value: !!values?.reports,
        defaultValue: !!values?.reports,
      },
    ],
    [values?.files, values?.finance, values?.planManagement, values?.reports]
  );
  return { fields };
};

export default useEmailCommunicationsFields;
